<template>
  <div class="home">
    
    <ParteDetalle/>
  </div>
</template>

<script>
// @ is an alias to /src
import ParteDetalle from '@/components/ParteDetalle.vue'

export default {
  name: 'ParteDetalleView',
  components: {
    ParteDetalle,
        
  }
}
</script>
<style scoped>
.home{
  height: 100%;
}
.fc{
  height: 100%;
}
</style>
